import React, { Component } from 'react';
import { connect } from 'react-redux';

import "./Login.css"
import logo from '../../source/logo-white.png';
// import bgImage from '../../source/bri-logo.jpeg';
import bgImage from '../../source/bri-logo-png.png';
import LoginComponent from "../../components/features/Login/LoginComponent"

class PageLogin extends Component{

    render(){
      return (
        <div className="limiter">
          <div className="container-login100">
            <div className="login100-more" style={{ backgroundImage: `url(${bgImage})` }}>
              <div className="landing-page-title">
                {/* <img className="media-object" src={ logo }></img>
                <p className="login-title">
                    Whatsapp Business Provide a simple communication platform between business and customers.
                </p>
                <p className="login-title">
                    Its a simple, efficient, & user-friendly customer engagement platform.
                </p> */}
              </div>
            </div>

            <div className="wrap-login100 p-l-50 p-r-50 p-t-72 p-b-50">
              <LoginComponent></LoginComponent>
            </div>
          </div>
        </div>
      );
  }
}

export default connect(
    (state) => {
        return {
            isLoggedIn: state.auth.isLoggedIn,
        }
    },
)(PageLogin);